import axios from 'axios';



let urlBack=process.env.REACT_APP_URL_API;

 const api = axios.create({
  baseURL: urlBack, 
  timeout: 5000,  
  headers: { 
    'Content-Type': 'application/json',   
  },
  withCredentials: true 
});


api.interceptors.request.use((config) => {
  const token = sessionStorage.getItem('AccessToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  };
  return config;
}, (error) => {
  return Promise.reject(error);
});



api.interceptors.response.use(
  (response) => {      
    if (response.headers['authorization']) {
     const token = response.headers['authorization'].split(' ')[1];
     sessionStorage.setItem('AccessToken', token);
    }
    return response;
  },(error) => { return Promise.reject(error);}
);



export default api